import React, { useState } from "react";

import Navbar from "components/Navbar";
import Lead from "components/Order/Lead";
import Form from "components/Order/Form";

export default function OrderPage() {
  const [isForm, setIsForm] = useState(false);
  return (
    <>
      <Navbar />
      {isForm ? <Form /> : <Lead setIsForm={setIsForm} />}
    </>
  )
}
